import React from 'react';
import {Link} from 'react-router-dom';
import TimeAgo from 'react-timeago';
import {
  Colors,
  Icon,
} from '@blueprintjs/core';

import {IconNames, IconName} from '@blueprintjs/icons';
import moment from 'moment';

import {formatDate} from '../../shared/components/dialogs/Trigger';
import {IWorkflow} from '../../shared/models';
import {typePathMap} from '../../shared/utils/typePathMap';
import {typePathIcon} from '../../shared/utils/typePathIcon';

type ScheduleElementProps = {
  schedule: IWorkflow;
};

const ScheduleElement = ({schedule}: ScheduleElementProps) => {
  const uid = schedule.report?.uid as string;
  const path = typePathMap(schedule.report?.type);
  const link = `/r/${path}edit/${uid}`;
  const icon = typePathIcon(schedule.report?.type, {color: Colors.INDIGO3}) as IconName;
  const name = schedule.report?.name;

  const onClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
  };
  const currentTimeUTC = moment().utc();
  const nextRunUTC = schedule.next_run ? `${schedule.next_run}Z` : null; // time in UTC

  let runIsInPast = false;
  if (nextRunUTC !== null) {
    runIsInPast = moment(nextRunUTC).utc().isBefore(currentTimeUTC);
  }

  const nextRunFn = (): Date => {
    /*
     * This is only called if nextRunUTC is not null
     */
    return new Date(nextRunUTC as string);
  };

  if (!uid) {
    return null;
  }

  return (
    <div className="home__content__block__item">
      <Link to={link} className="home__content__block__item__name__link">
        <Icon icon={icon} color={Colors.INDIGO3} />
        <div className="home__content__block__item__name">
          <div className="home__content__block__item__name__text">{name}</div>
        </div>
        <Icon icon={IconNames.TIME} color={Colors.GRAY3} size={12} />
        <div className="home__content__block__item__time bp4-text-overflow-ellipsis">
          {!runIsInPast && (
            <TimeAgo date={formatDate(nextRunFn())} minPeriod={60} />
          )}
        </div>
      </Link>
      <div onClick={onClick} className="home__content__block__item__action">
      {/* TODO - implement ScheduleElementInfo */}
      </div>
    </div>
  );
};

export default ScheduleElement;
